import React from 'react';
import { VendorsEditTemplate } from 'themes/application/vendors/pages';
import { observer } from 'mobx-react';
import { VendorsEditViewStore } from 'application/vendors/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new VendorsEditViewStore(rootStore), 'vendorsEditViewStore')
@observer
class VendorsEdit extends React.Component {
    render() {
        return <VendorsEditTemplate {...this.props} />
    }
}

export default VendorsEdit;
